export class Lagerplatz {
        // Artikelnummer
        public LSI_Artikelnummer: string;
        // Artikelvar
        public LSI_Artikelvar: string ;
        // Bezeichnung
        public AT_Bezeichnung1: string;
        // Lagernummer
        public LS_Lagernummer: string ;
        // Lagerplatztext
        public LS_Lagerplatztext: string ;
        // ZoneEin
        public LS_ZoneEin: string ;
        // ZoneAus
        public LS_ZoneAus: string ;
        // LagerplatzID
        public LS_LagerplatzID: number;
        // LHTyp 
        public LSI_LHTyp: string ;
        // LHAnzahl
        public LSI_LHAnzahl: number;
        // Menge die eingelagert ist
        public LSI_Menge: number;
        // MHDDatum
        public LSI_MHDDatum: string ;
        // Chargenr
        public LSI_Chargenr: string ;
        // TrackingIDNr / NVE
        public LSI_TrackingIDNr: string ;
        // Pruefstatus 
        public LSI_Pruefstatus: number;
        // Sperrgrund 
        public LSI_Sperrgrund: string ;
        // EinDatum 
        public LSI_EinDatum: Date ;
        // ID 
        public LSI_ID: number;
        // Lager Mengeneinheit
        public AT_LagerME: string ;


    constructor() {
    }
}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/models/lagerplatz.model.ts